export default {

    // APPLICATIONS
    ADD_OPS_APPLICATION: {
        url: "/api/v1/ops-team-application",
        method: "post",
    },
    GET_OPS_APPLICATIONS: {
        url: "/api/v1/ops-team-application",
        method: "get",
    },
    GET_OPS_APPLICATION_COUNTS: {
        url: "/api/v1/ops-team-application/counts",
        method: "get",
    },
    EXPORT_OPS_APPLICATION: {
        url: "/api/v1/ops-team-application/export",
        method: "get",
    },
    GET_OPS_APPLICATION_BY_ID: {
        url: "/api/v1/ops-team-application/{ops_application_id}",
        method: "get",
    },
    UPDATE_OPS_APPLICATION: {
        url: "/api/v1/ops-team-application/{ops_application_id}",
        method: "put",
    },
    DELETE_OPS_APPLICATION: {
        url: "/api/v1/ops-team-application/{ops_application_id}",
        method: "delete",
    },
    OPS_ASSIGN_APPLICATION: {
        url: "/api/v1/ops-team-application/assignment/{ops_application_id}",
        method: "put",
    },
}